// doctor sidebar

import { decryptData } from "./helpers";
import { checkModulePermission } from "./permissionsMiddleWare";

// Function to get current user data
const getCurrentUser = () => {
  return decryptData(
    localStorage.getItem("userInfo"),
    process.env.VUE_APP_SECRET_KEY
  );
};

// Function to check if user is admin
const isUserAdmin = user => {
  return user?.userRole?.some(e => e.name === "admin");
};

// Function to check if user is finance member
const isUserFinanceMember = user => {
  return user?.userRole?.some(e => e.name === "finance");
};

// Function to check if user is ady
const isUserAdy = user => {
  return user?.full_name === "ady_Uc" ? false : true;
};

// Function to generate sidebar based on current user
const generateSidebar = () => {
  const user = getCurrentUser();
  const userRole = isUserAdmin(user);
  const isAdy = isUserAdy(user);
  const isFinanceMember = isUserFinanceMember(user);
  const isAdmin = !userRole;

  return [
    // Patient Management Section
    {
      path: "/registration/register",
      name: "Registration",
      icon: "mdi mdi-account-plus-outline",
      disable: checkModulePermission("Registrations"),
      description: "Register new patients",
      section: "Patient Management"
    },
    {
      path: "/registration/patient-list",
      name: "Patient List",
      icon: "mdi mdi-view-list-outline",
      disable: checkModulePermission("Registrations"),
      description: "View all patients",
      section: "Patient Management"
    },
    {
      path: "/registration/patient-report",
      name: "Patient Report",
      icon: "mdi mdi-file-chart-outline",
      disable: checkModulePermission("Registrations"),
      description: "Patient statistics and reports",
      section: "Patient Management"
    },
    {
      path: "/registration/patient-registration-report",
      name: "Patient Regis.. Report",
      icon: "mdi mdi-file-chart-outline",
      disable: checkModulePermission("Registrations"),
      description: "Registration statistics",
      section: "Patient Management"
    },
    {
      path: "/registration/patient-status-report",
      name: "Patient Status Report",
      icon: "mdi mdi-clipboard-pulse-outline",
      disable: checkModulePermission("Registrations"),
      description: "Patient status overview",
      section: "Patient Management"
    },
    {
      path: "/registration/patient-detail-report",
      name: "Patient Details Report",
      icon: "mdi mdi-card-account-details-outline",
      disable: checkModulePermission("Registrations"),
      description: "Detailed patient information",
      section: "Patient Management"
    },

    // User Management Section
    {
      path: "/patients",
      name: "Patients",
      icon: "mdi-account-outline",
      disable: checkModulePermission("Patient"),
      description: "Patient database",
      section: "User Management"
    },
    {
      path: "/templates",
      name: "Templates",
      icon: "mdi-file-document-multiple-outline",
      disable: checkModulePermission("Template"),
      description: "Document templates",
      section: "User Management"
    },
    {
      path: "/patient-report",
      name: "Patient Report",
      icon: "mdi-chart-box-outline",
      disable: checkModulePermission("Patient Report"),
      description: "Comprehensive patient reports",
      section: "User Management"
    },

    // Reports Section
    {
      name: "Reports",
      icon: "mdi-chart-box-outline",
      disable: checkModulePermission("Report"),
      description: "Financial and operational reports",
      section: "Reports & Analytics",
      submenu: [
        {
          path: "/finance-reports",
          name: "Finance Report",
          icon: "mdi-chart-box-outline",
          disable: false,
          description: "Financial overview and analysis"
        },
        {
          path: "/doctor-reports",
          name: "Doctor Report",
          icon: "mdi-chart-box-outline",
          disable: isAdmin,
          description: "Doctor performance reports"
        },
        {
          path: "/daily-patients-report",
          name: "Patient Registration's",
          icon: "mdi-chart-box-outline",
          disable: false,
          description: "Daily patient registration statistics"
        },
        {
          path: "/expense-report",
          name: "Expense Report",
          icon: "mdi-chart-box-outline",
          disable: isAdmin,
          description: "Expense tracking and analysis"
        },
        {
          path: "/receivables-report",
          name: "Receivables Report",
          icon: "mdi-chart-box-outline",
          disable: false,
          description: "Accounts receivable reports"
        },
        {
          path: "/queue-report",
          name: "Queue Report",
          icon: "mdi-chart-box-outline",
          disable: isAdmin,
          description: "Patient queue management"
        }
      ],
      expanded: false
    },

    // System Management Section
    {
      path: "/users",
      name: "Users",
      icon: "mdi-account-multiple-outline",
      disable: checkModulePermission("User"),
      description: "Manage system users",
      section: "System Management"
    },
    {
      path: "/lookups",
      name: "Lookups",
      icon: "mdi-magnify",
      disable: checkModulePermission("Lookups"),
      description: "System lookups and references",
      section: "System Management"
    },
    {
      path: "/services",
      name: "Services",
      icon: "mdi-medical-bag",
      disable: checkModulePermission("Services"),
      description: "Manage hospital services",
      section: "System Management"
    },
    {
      path: "/charges",
      name: "Charges",
      icon: "mdi-receipt",
      disable: checkModulePermission("Charges"),
      description: "Service charges and pricing",
      section: "System Management"
    },
    {
      path: "/expenses",
      name: "Expenses",
      icon: "mdi-wallet-outline",
      disable: checkModulePermission("Expenses"),
      description: "Expense management",
      section: "System Management"
    },

    // Settings Section
    {
      name: "Settings",
      icon: "mdi-cog-outline",
      disable: checkModulePermission("Settings"),
      description: "System configuration and preferences",
      section: "Settings",
      submenu: isFinanceMember
        ? [
            {
              name: "Discount Settings",
              icon: "mdi mdi-ticket-percent-outline",
              path: "/panel-settings",
              description: "Configure discount policies"
            }
          ]
        : [
            {
              name: "Bussiness Settings",
              icon: "mdi-office-building-outline",
              path: "/bussiness-settings",
              description: "Business information and details"
            },
            {
              name: "Branch Settings",
              icon: "mdi-source-branch",
              path: "/branch-settings",
              description: "Branch-specific configurations"
            },
            {
              name: "Security Settings",
              icon: "mdi-shield-outline",
              path: "/security-settings",
              description: "Security and authentication settings"
            },
            {
              name: "Discount Settings",
              icon: "mdi mdi-ticket-percent-outline",
              path: "/panel-settings",
              description: "Configure discount policies"
            },
            {
              name: "RBAC Settings",
              icon: "mdi mdi-shield-account-outline",
              path: "/rbac-settings",
              description: "Role-based access control"
            },
            {
              name: "WhatsApp Settings",
              icon: "mdi mdi-whatsapp",
              path: "/whatsapp-settings",
              description: "WhatsApp delivery management"
            }
          ],
      showSubmenu: false
    },

    // System Tools Section
    {
      path: "/error-logs",
      name: "Error Logs",
      icon: "mdi-alert-circle-outline",
      disable: isAdy,
      description: "System error logs and debugging",
      section: "System Tools"
    }
  ];
};

// finance sidebar

const financeSidebar = [
  {
    path: "/doctors",
    name: "Doctors",
    icon: "mdi-stethoscope",
    disable: false,
    description: "Manage doctors and specialists",
    section: "Medical Staff"
  },
  {
    path: "/",
    name: "Users",
    icon: "mdi-account-details",
    disable: false,
    description: "User management",
    section: "User Management"
  },
  {
    name: "Reports",
    icon: "mdi-chart-box-outline",
    description: "Financial reports and analytics",
    section: "Reports & Analytics",
    submenu: [
      {
        path: "/finance-reports",
        name: "Finance Report",
        icon: "mdi-chart-box-outline",
        disable: false,
        description: "Financial overview"
      },
      {
        path: "/daily-patients-report",
        name: "Patient Registration's",
        icon: "mdi-chart-box-outline",
        disable: false,
        description: "Daily patient statistics"
      },
      {
        path: "/receivables-report",
        name: "Receivables Report",
        icon: "mdi-chart-box-outline",
        disable: false,
        description: "Accounts receivable"
      }
    ]
  },
  {
    path: "/services",
    name: "Services",
    icon: "mdi-medical-bag",
    disable: false,
    description: "Hospital services management",
    section: "Services"
  },
  {
    path: "/lookups",
    name: "Lookups",
    icon: "mdi-magnify",
    disable: false,
    description: "System references",
    section: "System"
  },
  {
    path: "/charges",
    name: "Charges",
    icon: "mdi-receipt",
    disable: false,
    description: "Service charges",
    section: "Finance"
  },
  {
    path: "/settings",
    name: "Settings",
    icon: "mdi-cog-outline",
    disable: false,
    description: "System settings",
    section: "Settings"
  }
];

export { generateSidebar, financeSidebar };
